import React from "react";
import { ClerkProvider } from "@clerk/clerk-react";
import { dark } from "@clerk/themes";
import { useTheme } from "./theme-provider";

interface ClerkThemeProviderProps {
  children: React.ReactNode;
  publishableKey: string;
  signInFallbackRedirectUrl: string;
  afterSignOutUrl: string;
  signUpFallbackRedirectUrl: string;
}

export const ClerkThemeProvider: React.FC<ClerkThemeProviderProps> = ({
  children,
  publishableKey,
  signInFallbackRedirectUrl,
  afterSignOutUrl,
  signUpFallbackRedirectUrl,
}) => {
  const { theme } = useTheme();

  return (
    <ClerkProvider
      publishableKey={publishableKey}
      signInFallbackRedirectUrl={signInFallbackRedirectUrl}
      afterSignOutUrl={afterSignOutUrl}
      signUpFallbackRedirectUrl={signUpFallbackRedirectUrl}
      appearance={{
        baseTheme: theme === "dark" ? dark : undefined,
        elements: {
          formButtonPrimary:
            "bg-slate-900 hover:bg-slate-800 text-white dark:bg-slate-100 dark:hover:bg-slate-200 dark:text-slate-900 transition-colors",
          card: "bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700",
          headerTitle: "text-slate-900 dark:text-slate-100",
          headerSubtitle: "text-slate-600 dark:text-slate-400",
          socialButtonsBlockButton:
            "bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-900 dark:text-slate-100 hover:bg-slate-50 dark:hover:bg-slate-700",
          formFieldInput:
            "bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-900 dark:text-slate-100",
          formFieldLabel: "text-slate-700 dark:text-slate-300",
          identityPreviewText: "text-slate-600 dark:text-slate-400",
          identityPreviewEditButton: "text-slate-700 dark:text-slate-300",
          menuButton:
            "text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800",
          menuList:
            "bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700",
          menuItem:
            "text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800",
          userButtonPopoverCard:
            "bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700",
          userButtonPopoverActionButton:
            "text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800",
          userButtonPopoverActionButtonText:
            "text-slate-700 dark:text-slate-300",
        },
        variables: {
          colorPrimary: theme === "dark" ? "#f1f5f9" : "#0f172a",
          colorBackground: theme === "dark" ? "#0f172a" : "#ffffff",
          colorInputBackground: theme === "dark" ? "#0f172a" : "#ffffff",
          colorInputText: theme === "dark" ? "#f1f5f9" : "#0f172a",
        },
      }}
    >
      {children}
    </ClerkProvider>
  );
};
